import React from 'react';

import { Box } from '@mui/material';

import { useTranslation } from 'next-i18next';

// Assets
import BackLink from 'src/components/ui/BackLink';

import useAppRouter from 'src/hooks/useAppRouter';
import usePreviousRoute from 'src/hooks/usePreviousRoute';
import { routePathCommunity } from 'src/constants/router';

const ProfileTopBar: React.FC = () => {
    const { t } = useTranslation(['common']);
    const router = useAppRouter();
    const { previousRoute, canGoBack } = usePreviousRoute();
    return (
        <Box pt={3} pb={2} display="flex" alignItems="center" justifyContent="space-between">
            <BackLink onClick={() => router.push(canGoBack && previousRoute ? previousRoute : routePathCommunity)}>
                {t('common:back')}
            </BackLink>
        </Box>
    );
};

export default ProfileTopBar;
